export { default } from './ApartmentsPage';
